import React from 'react';
import * as Sentry from '@sentry/react';
import {SENTRY} from '../../constants'

SENTRY && Sentry.init({
    dsn: SENTRY,
    environment: process.env.NODE_ENV,
    beforeSend: function(event, hint) {
        // filter out UnhandledRejection errors that have no information
        if (event !== undefined && event.exception !== undefined && event.exception.values !== undefined
            && event.exception.values.length === 1) {
            let e = event.exception.values[0];
            if (e.type === 'UnhandledRejection'
                && e.value === 'Non-Error promise rejection captured with value: Object Not Found Matching Id:2') {
                return null;
            }
        }
    }
});

const logError = (error, info) => {
    console.log("panic error, info >> ", error, info);
    Sentry.captureException(error)
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // You can also log the error to an error reporting service
        logError(error, info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <h1>Something went wrong.</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;